import React, { PureComponent } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Legend, Tooltip } from "recharts";

export default class OptimizerPieChart extends PureComponent {
  render() {
    const { isSmall, pData, showSegments, unit, onClick, hideLegend, hideTooltip, isNext } = this.props;

    if (pData === undefined) {
      return <div />;
    }

    const total = pData.reduce((a, b) => a + b.value, 0);

    return (
      <ResponsiveContainer>
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie
            data={pData}
            innerRadius={isNext ? 45 : isSmall ? 15 : 30}
            outerRadius={isNext ? 50 : isSmall ? 25 : 50}
            fill="#8884d8"
            paddingAngle={showSegments ? 6 : 1}
            dataKey="value"
            onClick={
              !onClick
                ? undefined
                : (e) => e && e.payload && e.payload.payload && onClick(e.payload.payload.runId, e.payload.payload.name)
            }
          >
            {pData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.color}
                // strokeWidth={showSegments ? 2 : 0}
                stroke={entry.color}
              />
            ))}
          </Pie>
          {!hideTooltip && (
            <Tooltip
              formatter={(value, name, props) => unit + value + " (" + Math.round((props.value / total) * 100) + "%)"}
            />
          )}
          {!hideLegend && (
            <Legend
              layout={"vertical"}
              align={"right"}
              verticalAlign={pData.length < 6 ? "middle" : "top"}
              width={isSmall ? 210 : 180}
              formatter={(value, entry, index) => value + ": " + Math.round((pData[index].value / total) * 100) + "%"}
              iconType={"circle"}
            />
          )}
        </PieChart>
      </ResponsiveContainer>
    );
  }
}
